var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.28 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: #150e28;\n      }\n\n      .cls-1, .cls-4, .cls-5, .cls-9, .cls-7, .cls-10 {\n        font-weight: 600;\n      }\n\n      .cls-1, .cls-5, .cls-9, .cls-11, .cls-10 {\n        font-family: MontserratAlternates-SemiBold, 'Montserrat Alternates';\n      }\n\n      .cls-12 {\n        font-size: 11px;\n      }\n\n      .cls-12, .cls-2, .cls-13, .cls-14 {\n        font-family: MontserratAlternates-Medium, 'Montserrat Alternates';\n        font-weight: 500;\n      }\n\n      .cls-12, .cls-15, .cls-16, .cls-17 {\n        fill: #6a2fea;\n      }\n\n      .cls-2, .cls-18, .cls-5, .cls-6, .cls-13, .cls-7, .cls-14 {\n        font-size: 12px;\n      }\n\n      .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-14, .cls-10 {\n        fill: #08213f;\n      }\n\n      .cls-15 {\n        opacity: .1;\n      }\n\n      .cls-20 {\n        font-family: MontserratAlternates-ExtraBoldItalic, 'Montserrat Alternates';\n        font-size: 32px;\n      }\n\n      .cls-20, .cls-4 {\n        font-style: italic;\n      }\n\n      .cls-20, .cls-6, .cls-16 {\n        font-weight: 700;\n      }\n\n      .cls-24, .cls-21 {\n        stroke-linecap: round;\n        stroke-width: .75px;\n      }\n\n      .cls-24, .cls-21, .cls-22, .cls-23 {\n        stroke: #08213f;\n      }\n\n      .cls-24, .cls-22, .cls-23, .cls-8, .cls-25 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-24, .cls-25 {\n        fill: none;\n      }\n\n      .cls-26, .cls-9 {\n        font-size: 9px;\n      }\n\n      .cls-21 {\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        font-family: MontserratAlternates-SemiBoldItalic, 'Montserrat Alternates';\n        font-size: 10px;\n      }\n\n      .cls-27 {\n        font-family: Montserrat-SemiBold, Montserrat;\n      }\n\n      .cls-22 {\n        stroke-width: .3px;\n      }\n\n      .cls-23 {\n        stroke-width: .2px;\n      }\n\n      .cls-6, .cls-16 {\n        font-family: MontserratAlternates-Bold, 'Montserrat Alternates';\n      }\n\n      .cls-8 {\n        stroke: #150e28;\n        stroke-width: .5px;\n      }\n\n      .cls-16, .cls-10 {\n        font-size: 14px;\n      }\n\n      .cls-25 {\n        stroke: #6a2fea;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(35 57.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Vaibhav Kothi")), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(40.02 81.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Designer &amp; Illustrator")), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://vaibhav.wtf"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(40.02 104.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Portfolio")), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M104.64,101.95l5.37-5.37v3.29c0,.12.09.21.21.21s.21-.09.21-.21v-3.8s0-.05-.01-.08h0s0,0,0,0c-.02-.05-.06-.09-.11-.11,0,0,0,0,0,0-.02,0-.05-.01-.08-.01h-3.8c-.12,0-.21.09-.21.21s.09.21.21.21h3.29s-5.37,5.37-5.37,5.37l.3.3ZM104.19,102.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 103.93,
    y1: 105.63,
    x2: 110.84,
    y2: 105.63
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(40 135.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PROFILE")), /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(40 157.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "India based graphic designer and digital illustrator "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "with a passion for story telling.")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(422.5 159.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(437.85 155.17) scale(.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "th")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(445.66 159.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " September 1999"))), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(420.24 185.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Male")), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M412.2,175.47s0,0,0,0c-.02-.04-.05-.08-.1-.1,0,0,0,0,0,0-.02,0-.04-.01-.07-.01h-3.3c-.1,0-.18.08-.18.18s.08.18.18.18h2.86s-3.23,3.23-3.23,3.23c-.68-.62-1.55-.95-2.47-.95-.98,0-1.91.38-2.6,1.08-.7.7-1.08,1.62-1.08,2.6s.38,1.91,1.08,2.6c.7.7,1.62,1.08,2.6,1.08s1.91-.38,2.6-1.08c.7-.7,1.08-1.62,1.08-2.6,0-.92-.34-1.79-.95-2.47l3.23-3.23v2.86c0,.1.08.18.18.18s.18-.08.18-.18v-3.3s0-.05-.01-.07h0ZM408.24,184.02c-.63.63-1.46.97-2.34.97s-1.72-.34-2.34-.97c-.63-.63-.97-1.46-.97-2.34s.34-1.72.97-2.34c.63-.63,1.46-.97,2.34-.97s1.72.34,2.34.97c.63.63.97,1.46.97,2.34,0,.89-.34,1.72-.97,2.34h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M409.88,155.91c-.37.37-.87.57-1.39.57s-1.02-.21-1.39-.57c-.06-.06-.15-.06-.2,0-.06.06-.06.15,0,.2.42.42,1,.66,1.59.66s1.17-.24,1.59-.66c.05-.06.05-.14,0-.19-.05-.05-.14-.06-.19,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M413.58,152.79c-.57-1.35-1.79-2.34-3.48-2.73-.51-.11-1.03-.17-1.55-.17-.64,0-1.27.08-1.88.26-.06-.19-.09-.39-.09-.6,0-.08-.06-.14-.14-.14s-.14.06-.14.14c0,.23.03.46.1.68-1.09.34-2.02,1.06-2.63,2.02-.11.17-.2.35-.28.53-.85,0-1.27.61-1.27,1.81,0,.89.36,1.93,1.34,1.98.8,1.72,2.65,2.84,4.98,2.84s4.15-1.13,4.94-2.84h.02c.82,0,1.28-.76,1.28-2.09.01-.41,0-1.66-1.21-1.7h0ZM402.51,154.6c0-1.24.47-1.48.88-1.52-.17.49-.25,1-.25,1.52,0,.57.1,1.14.31,1.68-.69-.12-.94-.96-.94-1.68h0ZM408.55,159.12c-2.97,0-5.12-1.91-5.12-4.52-.01-.77.19-1.53.59-2.2.58-.91,1.46-1.58,2.49-1.9.18.4.48.75.85.99.37.24.8.37,1.25.37.08,0,.14-.06.14-.14s-.06-.14-.14-.14c-.38,0-.76-.11-1.08-.31-.32-.21-.58-.5-.74-.84.58-.16,1.17-.24,1.77-.24.5,0,1,.05,1.49.16,2.23.51,3.61,2.13,3.61,4.24,0,2.63-2.14,4.55-5.1,4.55h0ZM413.6,156.29c.21-.55.32-1.13.32-1.72,0-.5-.08-1-.24-1.48.57.07.83.5.83,1.41.01.52-.08,1.7-.9,1.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M411.92,153.37c-.35-.21-.76-.32-1.17-.32s-.82.11-1.17.32c-.06.04-.08.13-.04.19.04.06.12.09.18.05.31-.19.66-.28,1.03-.28s.72.1,1.03.28c.03.02.07.03.11.02.04,0,.07-.03.09-.06.02-.03.03-.07.02-.11-.01-.04-.04-.07-.07-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M407.45,153.57s.03-.07.02-.11c0-.04-.03-.07-.06-.09-.35-.21-.76-.32-1.17-.32s-.82.11-1.17.32c-.06.04-.08.13-.04.19.04.06.12.09.18.05.31-.19.66-.28,1.03-.28s.72.1,1.03.28c.03.02.07.03.11.02s.07-.03.09-.06h0Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.55 364.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Associate UI/UX Designer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(261.52 364.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2021 - 2022 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 70.7,
    y: 0
  }, "(1 Year)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.35 313.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Social Media Designer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(85.35 330.64)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Paytm Insider")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(187.87 330.76)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2022"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 29.56,
    y: 0,
    xmlSpace: "preserve"
  }, " (6 Months)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(40 208.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EXPERIENCE")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.55 390.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UI/UX Intern")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(85.55 408.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Streebo Inc.")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(173.25 408.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2021 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 29.38,
    y: 0
  }, "(6 Months)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.55 441.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Senior Design Consultant")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(257.79 441.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2020 - 2021 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 71.78,
    y: 0
  }, "(1.5 Years)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.55 467.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Junior Design Consultant")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(85.55 484.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Beknown.Digital")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(204.01 484.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2019"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 27.62,
    y: 0,
    xmlSpace: "preserve"
  }, " (6 Months)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.35 516.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Freelance Designer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(85.35 533.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25+ Happy Clients")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(212.08 534.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2019 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 30.13,
    y: 0
  }, "(1 Year)")), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M74.2,328.89c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M74.2,483.82c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M74.2,328.89c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M74.2,406.32c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M74.2,406.32c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M74.2,483.82c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.66,514.77c-.18.72-.74,1.28-1.46,1.46-.87.21-1.96.39-3.21.38-1.22,0-2.27-.18-3.13-.39-.7-.17-1.26-.73-1.43-1.43-.21-.86-.39-1.93-.39-3.17,0-1.23.17-2.31.38-3.17.18-.72.74-1.28,1.46-1.46.88-.22,1.96-.39,3.22-.38,1.21,0,2.27.18,3.12.39.7.17,1.26.73,1.43,1.43.21.84.38,1.89.39,3.08,0,1.27-.17,2.37-.38,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.66,363.21c-.18.72-.74,1.28-1.46,1.46-.87.21-1.96.39-3.21.38-1.22,0-2.27-.18-3.13-.39-.7-.17-1.26-.73-1.43-1.43-.21-.86-.39-1.93-.39-3.17,0-1.23.17-2.31.38-3.17.18-.72.74-1.28,1.46-1.46.88-.22,1.96-.39,3.22-.38,1.21,0,2.27.18,3.12.39.7.17,1.26.73,1.43,1.43.21.84.38,1.89.39,3.08,0,1.27-.17,2.37-.38,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.87,440.61c-.18.72-.74,1.28-1.46,1.46-.87.21-1.96.39-3.21.38-1.22,0-2.27-.18-3.13-.39-.7-.17-1.26-.73-1.43-1.43-.21-.86-.39-1.93-.39-3.17,0-1.23.17-2.31.38-3.17.18-.72.74-1.28,1.46-1.46.88-.22,1.96-.39,3.22-.38,1.21,0,2.27.18,3.12.39.7.17,1.26.73,1.43,1.43.21.84.38,1.89.39,3.08,0,1.27-.17,2.37-.38,3.26Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 58.25,
    y1: 509,
    x2: 58.25,
    y2: 490.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 58.25,
    y1: 455.26,
    x2: 58.25,
    y2: 442.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 58.25,
    y1: 432.77,
    x2: 58.25,
    y2: 412.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 58.25,
    y1: 377.77,
    x2: 58.25,
    y2: 335.33
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.55 286.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Senior Associate Designer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(262.26 287.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2022 - 2024 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 74.06,
    y: 0
  }, "(1.5 Years)")), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.66,285.77c-.18.72-.74,1.28-1.46,1.46-.87.21-1.96.39-3.21.38-1.22,0-2.27-.18-3.13-.39-.7-.17-1.26-.73-1.43-1.43-.21-.86-.39-1.93-.39-3.17,0-1.23.17-2.31.38-3.17.18-.72.74-1.28,1.46-1.46.88-.22,1.96-.39,3.22-.38,1.21,0,2.27.18,3.12.39.7.17,1.26.73,1.43,1.43.21.84.38,1.89.39,3.08,0,1.27-.17,2.37-.38,3.26Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 58.25,
    y1: 300.33,
    x2: 58.25,
    y2: 257.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M49.92,315.55c-1.14,1.13-1.18,3.01-.02,4.13l1.94,1.94,4.15-4.15-1.92-1.92c-1.15-1.12-3.01-1.12-4.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.05,315.55c1.14,1.13,1.18,3.01.02,4.13l-1.94,1.94-4.15-4.15,1.92-1.92c1.15-1.12,3.01-1.12,4.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M51.83,321.62l3.09,3.09c.55.53,1.56.56,2.1.02l3.11-3.11-4.15-4.15-4.15,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.89,314.71c-.67-.67-1.57-1.11-2.54-1.2h-.02s-.07-.02-.1-.05c-.07-.07-.07-.17,0-.24l1.82-1.82c1.11-1.16,3-1.12,4.13.02h-.01c1.14,1.14,1.19,3.01.04,4.13l-1.82,1.82c-.07.07-.17.07-.24,0-.03-.03-.04-.06-.05-.1v-.02c-.09-.97-.53-1.87-1.21-2.54h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "LogoMark",
    className: "cls-17",
    d: "M64.17,387.3h-12.26c-1.03,0-1.87.84-1.87,1.87v6.89c0,1.03.84,1.87,1.87,1.87h3.45v3.45c0,1.03.84,1.87,1.87,1.87h6.94c1.03,0,1.87-.84,1.87-1.87v-12.26c.05-.98-.79-1.82-1.87-1.82ZM63.39,399.9c0,.39-.34.74-.74.74h-4.58v-5.32h-4.58c-.39,0-.74-.34-.74-.74v-3.84c0-.39.34-.74.74-.74h4.58v5.32h4.58c.39,0,.74.34.74.74v3.84h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M57.51,474.92c.1-.12.2-.25.31-.39-.05.82-.12,1.67-.22,2.62-.12,1.08-.47,1.33-1.09,1.47-.86.17-1.96.24-2.78.24-3.27,0-5.68-1.82-5.68-4.08,0-.89.38-1.54,1-1.99.05-.03.1-.06.16-.06,1.2-.14,2.55-.24,4.03-.24,1.53,0,2.92.1,4.15.25-.27.7-1.25.94-1.38,1.58-.04.22.02.43.14.6.33.46,1.02.45,1.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M57.92,469.37c-.15-.18-.28-.35-.41-.51-.34-.45-1.03-.46-1.36,0-.12.17-.18.37-.14.6.14.64,1.11.88,1.38,1.58-2.15.28-5.08.33-7.37.1-.07,0-.14-.04-.19-.09-.67-.59-1.09-1.3-1.09-2.13,0-1.62,2.44-2.26,4.82-2.26,1.25,0,2.35.06,3.34.19.59.08,1.03.57,1.03,1.16,0,.45,0,.9,0,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.07,469.39c.72-.02,1.45-.02,2.17-.02,1.01,0,1.99.03,2.86.03.64,0,.86-.25.91-.69.03-.27.03-.25.03-.52s-.02-.52-.05-.77c-.07-.52-.32-.64-1.03-.67-.66-.02-1.31-.03-2-.03-1.61,0-3.3.06-4.98.15-.5.03-.9.43-.93.94-.04.88-.06,1.79-.06,2.72.29.27.58.5.86.66.23.16.38.43.38.71,0,.28-.15.55-.38.71-.26.15-.53.37-.8.61.02.51.05,1.02.08,1.51h0c.05.86.14,1.73.25,2.66.15,1.04.39,1.26.99,1.3.96.05,2.02.08,3.17.08.99,0,2.04-.03,3.13-.1.91-.05,1.11-.1,1.21-.71.03-.27.07-.54.07-.81,0-.22-.02-.44-.07-.64-.08-.4-.25-.49-.74-.49-.44,0-2.08.15-4.72.15,0,0-.02,0-.02-.02l-.16-3.19s0-.02.02-.02h.93c1.67,0,1.69-.03,2.85-.14.51-.03.79-.22.84-.66.03-.2.03-.09.03-.28,0-.29-.02-.56-.08-.83-.12-.45-.35-.57-1.18-.61-1.03-.05-.51-.07-1.55-.07-.68,0-1.35.02-2.01.03,0,0-.02,0-.02-.02-.05-.71-.02-.22-.03-1,0,0,0-.02.02-.02Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(85.35 235.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Senior Designer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(85.35 252.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 0,
    y: 0
  }, "Z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 8.2,
    y: 0
  }, "omato")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(145.65 252.91)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "2024"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 30.47,
    y: 0,
    xmlSpace: "preserve"
  }, " (present)")), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M74.2,251.04c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M74.2,251.04c-.62,2.52-2.58,4.48-5.1,5.1-3.06.75-6.86,1.36-11.24,1.34-4.25-.02-7.96-.62-10.95-1.36-2.47-.61-4.41-2.55-5.02-5.02-.75-3.02-1.35-6.77-1.36-11.08,0-4.32.6-8.08,1.34-11.1.62-2.52,2.58-4.48,5.1-5.1,3.06-.75,6.88-1.36,11.26-1.34,4.24.02,7.94.62,10.92,1.36,2.46.61,4.4,2.55,5.01,5.01.73,2.96,1.33,6.61,1.36,10.79.03,4.44-.58,8.3-1.34,11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M48.18,237.52l-.03.82-2.14,2.33c.89,0,1.46,0,1.79-.03-.09.44-.17.8-.25,1.34-.43-.04-1.1-.05-1.77-.05-.75,0-1.4,0-1.93.05l.02-.83,2.14-2.32c-.94,0-1.28,0-1.67.02.09-.42.15-.87.21-1.34.68.03.95.04,1.83.04.82,0,1.28,0,1.8-.04h0ZM50.61,237.27c-1.39,0-2.46,1.25-2.46,2.73,0,1.12.64,1.98,1.9,1.98,1.4,0,2.46-1.25,2.46-2.74,0-1.11-.63-1.97-1.9-1.97h0ZM50.19,240.79c-.31,0-.49-.28-.49-.83,0-.82.34-1.48.75-1.48.3,0,.48.27.48.83,0,.81-.33,1.48-.74,1.48ZM70.31,237.21c-1.41,0-2.49,1.26-2.49,2.77,0,1.13.65,2,1.93,2,1.42,0,2.49-1.26,2.49-2.78,0-1.12-.64-1.99-1.93-1.99h0ZM69.86,240.78c-.31,0-.49-.28-.49-.83,0-.82.34-1.48.75-1.48.3,0,.48.27.48.83,0,.81-.33,1.48-.74,1.48ZM59.75,238.9c.11-.77.05-1.46-.8-1.46-.62,0-1.29.52-1.76,1.4.1-.72.04-1.4-.8-1.4-.64,0-1.32.55-1.8,1.46.12-.6.09-1.27.06-1.42-.49.08-.92.13-1.52.14.02.42,0,.96-.09,1.47l-.2,1.35c-.08.53-.16,1.15-.25,1.53h1.6c0-.23.07-.6.11-.93l.14-.93c.11-.6.59-1.32.96-1.32.22,0,.21.21.15.6l-.15,1.05c-.08.53-.16,1.15-.25,1.53h1.62c0-.23.06-.6.1-.93l.14-.93c.11-.6.59-1.32.96-1.32.22,0,.21.2.17.47l-.39,2.71h1.48l.52-3.09ZM67.47,240.57l-.17,1.06c-.27.14-.77.35-1.34.35-.98,0-1.18-.52-1.02-1.63l.25-1.79h-.48l.14-1.16.53-.03.2-.84,1.49-.56-.19,1.4h1.02c-.03.14-.16.94-.19,1.18h-1l-.22,1.65c-.06.42-.03.58.27.58.22,0,.53-.13.73-.23h0ZM61.83,241.14c.54-.07.91-.59,1-1.11l.02-.14c-.23-.05-.57-.09-.89-.05-.31.04-.57.17-.71.35-.1.13-.16.29-.13.49.04.29.35.51.72.46ZM61.37,241.97c-.76.09-1.27-.21-1.42-.9-.09-.43.04-.93.27-1.22.31-.39.81-.63,1.42-.71.49-.06.91-.03,1.3.04l.02-.07c.01-.11.02-.21,0-.34-.04-.33-.3-.52-.94-.44-.43.05-.84.21-1.16.38l-.31-.93c.43-.25.97-.44,1.59-.51,1.19-.15,2.02.23,2.13,1.1.03.23.03.48,0,.7-.15,1.07-.25,1.88-.29,2.43,0,.08,0,.23,0,.43h-1.47c.03-.09.06-.2.08-.35.02-.09.03-.21.04-.36-.31.43-.74.68-1.27.75h0Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 374.42,
    width: 112.92,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.65 389.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Illustrations")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 401.88,
    width: 97.11,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.65 417.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Branding")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 429.33,
    width: 116.49,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.65 444.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Print Design")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 456.78,
    width: 144.45,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.65 471.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Digital Marketing")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 484.24,
    width: 155.88,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.65 499.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Application Design")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 511.69,
    width: 159.34,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 526.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Photo Manipulation")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 594.06,
    width: 122.66,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 609.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Video Editing")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 621.51,
    width: 124.49,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 636.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Visual Effects")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 648.96,
    width: 125.5,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 664.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sound Design")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 676.42,
    width: 148.54,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 691.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Product Packging")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 703.87,
    width: 141.08,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 719.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "User Experience")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 731.33,
    width: 114.95,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 746.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Design")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 539.15,
    width: 125.5,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 554.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Color Grading")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 566.6,
    width: 126.23,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 403.48,
    y: 759.89,
    width: 72.71,
    height: 21.76,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 775.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3D Art")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(420.11 581.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Poster Design")), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(403.38 360.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SKILLS")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(86.28 601.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Graduation")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(86.28 618.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 0,
    y: 0
  }, "Bachelor of Technology "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 158.11,
    y: 0
  }, "(Information Technology)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(40.01 637.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Scored: 8.66 /10 CGPA")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(169.74 601.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2017 - 2021")), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(39.47 574.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ACADEMICS")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(40.43 655.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "From A. D. Patel Institute of Technology, Anand "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "GJ under Gujarat Technological University")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(86.65 729.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(98.69 725.17) scale(.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "th")), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(106.58 729.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " (XII) - Science"))), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(40 749.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Scored: 77.20 %")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(40.43 766.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "From Saraswati International School, Valsad, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "GJ under Central Board of Secondary Education")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(86.41 710.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Senior School")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(186.73 710.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2015 - 2017")), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M61.04,609.76c-.42,0-1.05-.05-1.63-.27l-6.53-2.52v3.39s2.09,3.04,8.16,3.04,8.16-3.04,8.16-3.04v-3.39l-6.53,2.52c-.58.22-1.21.27-1.63.27h0ZM75.54,602.67l-13.28-5.12c-.67-.26-1.77-.26-2.44,0l-13.28,5.12c-.67.26-.67.68,0,.94l13.28,5.12c.67.26,1.77.26,2.44,0l9.46-3.65v3.09c-.39.19-.83.62-.85,1.54-.05,1.71.14,2.75-.76,3.56,0,0,.36.43,1.13.33l.49-1.61s.18.54.24,1.63c0,0,1.19.03,1.47-.39,0,0,.8-3.83-.43-4.93v-3.7l2.54-.98c.67-.26.67-.68,0-.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M75.37,716.67c-.57-.46-1.35-.43-1.87-.19-1.52.69-1.38,2.78-1.37,2.87.02.27.26.48.54.46.27-.02.48-.26.46-.54,0-.01-.1-1.48.79-1.89.16-.07.57-.15.82.05.33.27.39,1,.17,2.01-.17.77-.51,1.32-1.01,1.63-.58.36-1.25.32-1.56.27-.99-1.53-1.31-2.84-.94-3.9.52-1.49,2.25-2.04,2.27-2.05.23-.07.38-.3.35-.55-.03-.24-.24-.43-.48-.43-3.14-.07-6.74-.57-10.69-1.47l-3.73-.94c-5.51-1.52-9.62-3.22-9.66-3.24-.13-.05-.27-.05-.4,0-1.58.72-2.55,1.73-2.88,2.99-.54,2.04.82,3.94.88,4.02.09.12.23.2.38.21,2.6.11,5.73.6,9.31,1.45l-4.38,3.31c-.18.14-.25.38-.16.59.09.21.31.33.53.3l2.89-.42.26,2.06c.02.19.15.34.33.41.05.02.11.03.17.03.13,0,.25-.05.34-.14l5.07-4.78c5.58,1.65,10.01,3.44,10.05,3.46.01,0,.02,0,.03,0,0,0,.02.01.03.01.03,0,.36.09.82.09s1.1-.09,1.68-.44c.74-.45,1.24-1.21,1.47-2.27.32-1.45.15-2.47-.51-3h0ZM56.75,722.19l-.2-1.59c-.02-.13-.09-.25-.19-.33-.11-.08-.24-.12-.37-.1l-1.47.21,3.48-2.62,2.68.73-3.92,3.69ZM61.78,713.89c-.05.07-.09.15-.13.22-.05.09-.1.18-.14.27-.02.04-.04.09-.06.13-.48,1.12-.49,2.29-.41,3.05l-2.77-.75c-.02-.07-.04-.14-.06-.2-.01-.05-.03-.1-.04-.15-.03-.12-.05-.24-.07-.35,0-.02-.01-.05-.02-.07-.02-.14-.04-.27-.04-.39,0-.03,0-.07,0-.1,0-.09,0-.18,0-.27,0-.04,0-.08,0-.12,0-.07.01-.15.02-.22,0-.04.01-.08.02-.12.01-.07.03-.13.04-.2,0-.03.02-.07.03-.1.02-.07.04-.13.06-.2,0-.02.02-.05.03-.07.03-.08.07-.17.11-.24,0,0,.01-.02.02-.03.03-.07.07-.13.1-.19.01-.02.03-.04.04-.07.03-.04.06-.09.09-.13.02-.02.03-.04.05-.06.03-.04.06-.07.08-.1.02-.02.03-.04.05-.06.03-.03.06-.06.08-.09.01-.01.03-.03.04-.04.03-.03.07-.06.1-.09l.02-.02s.06-.05.09-.08l2.78.7s-.05.09-.08.14h0Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(403.22 231.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONTACT")), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "tel: +918866827025"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(419.77 273.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+91 88668 27025")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(403.77 255.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Phone")), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M406.48,263.9c-.19,0-.38.09-.51.24l-.96,1.05s0,0-.03.04h0s-.03.04-.03.06c-.39,1.24-.13,2.6.51,3.9.64,1.3,1.65,2.54,2.81,3.56,1.16,1.02,2.48,1.81,3.73,2.21,1.25.4,2.47.39,3.36-.26h0s.02-.02.03-.02c.02-.02.02-.03.02-.02h0s.95-1.05.95-1.05c.27-.3.25-.77-.05-1.05l-2.26-2.05c-.3-.27-.77-.25-1.05.05l-1.02,1.12c-.83-.24-1.54-.65-2.22-1.27-.68-.62-1.15-1.29-1.47-2.09l1.02-1.12c.27-.3.25-.77-.05-1.05l-2.26-2.05c-.15-.14-.34-.2-.53-.19h0ZM406.5,264.36c.07,0,.14.02.2.07l2.26,2.05c.12.11.12.27.02.39l-1.13,1.24h0c-.06.06-.08.15-.05.24.34.93.9,1.7,1.66,2.39s1.58,1.17,2.54,1.42h0c.08.02.17,0,.23-.07l1.13-1.24c.11-.12.27-.12.39-.02l2.26,2.05c.12.11.12.27.02.39l-.94,1.04c-.74.53-1.78.56-2.94.19-1.17-.37-2.44-1.13-3.56-2.12-1.12-.98-2.1-2.18-2.7-3.41-.59-1.21-.81-2.44-.48-3.52l.92-1.01c.05-.06.12-.09.19-.09h0Z"
  }))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "mailto: sampark@vaibhav.wtf"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(422.01 318.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sampark@vaibhav.wtf"))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "mailto: sampark@vaibhav.wtf"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(403.77 301.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Email"))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "mailto: sampark@vaibhav.wtf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.71,320.5h8.03c.53,0,1.03-.21,1.4-.58.37-.37.58-.87.58-1.4v-6.04c0-.53-.21-1.03-.58-1.4-.37-.37-.87-.58-1.4-.58h-8.03c-.53,0-1.03.21-1.4.58-.37.37-.58.87-.58,1.4v6.04c0,.53.21,1.03.58,1.4.37.37.87.58,1.4.58ZM416.01,318.52h0c0,.34-.13.66-.37.9-.24.24-.56.37-.9.37h-8.03c-.34,0-.66-.13-.9-.37-.24-.24-.37-.56-.37-.9v-6.04c0-.25.07-.49.21-.7l4.06,3.34c.29.23.64.36,1.01.36s.73-.13,1.01-.36l4.06-3.34c.14.21.21.45.21.7v6.04ZM414.74,311.21c.17,0,.34.04.5.11l-3.96,3.26c-.16.13-.36.2-.56.2s-.4-.07-.56-.2l-3.96-3.26c.16-.07.33-.11.5-.11h8.03Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0,
    y: 807.57,
    width: 595.28,
    height: 34.32
  }), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://www.instagram.com/vaibhav.wtf/"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(55.82 828.31)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/ vaibhav.wtf")), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50.43,822.11v4.26c0,.76-.3,1.49-.84,2.03s-1.27.84-2.03.84h-4.26c-.76,0-1.49-.3-2.03-.84s-.84-1.27-.84-2.03v-4.26c0-.76.3-1.49.84-2.03s1.27-.84,2.03-.84h4.26c.76,0,1.49.3,2.03.84.54.54.84,1.27.84,2.03ZM49.8,822.11c0-.59-.24-1.16-.66-1.58-.42-.42-.99-.65-1.58-.66h-4.26c-.59,0-1.16.24-1.58.66-.42.42-.65.99-.66,1.58v4.26c0,.59.24,1.16.66,1.58.42.42.99.65,1.58.66h4.26c.59,0,1.16-.24,1.58-.66.42-.42.65-.99.66-1.58v-4.26ZM48.78,821.17s-.03-.06-.05-.09c-.02-.03-.04-.06-.07-.08-.03-.02-.05-.05-.08-.07-.03-.02-.06-.04-.09-.05-.03-.01-.07-.02-.1-.03-.07-.01-.14-.01-.21,0-.03,0-.07.02-.1.03-.03.01-.06.03-.09.05-.03.02-.06.04-.08.07-.02.03-.05.05-.07.08-.02.03-.04.06-.05.09-.01.03-.02.07-.03.1-.01.07-.01.14,0,.21,0,.03.02.07.03.1.01.03.03.06.05.09.02.03.04.06.07.08.02.02.05.05.08.07.03.02.06.04.09.05.03.01.07.02.1.03.07.01.14.01.21,0,.03,0,.07-.02.1-.03.03-.01.06-.03.09-.05.03-.02.06-.04.08-.07.02-.03.05-.05.07-.08.04-.06.07-.12.08-.19.01-.07.01-.14,0-.21,0-.03-.02-.07-.03-.1h0ZM45.43,826.86c-.7,0-1.36-.27-1.85-.77-.5-.5-.77-1.15-.77-1.85s.27-1.36.77-1.85c.5-.5,1.15-.77,1.85-.77.7,0,1.36.27,1.85.77.49.49.77,1.15.77,1.85h0c0,.7-.27,1.36-.77,1.85-.5.5-1.15.77-1.85.77ZM45.43,822.1c-.57,0-1.11.22-1.51.63-.4.4-.63.94-.63,1.51s.22,1.11.63,1.51c.4.4.94.63,1.51.63s1.11-.22,1.51-.63c.4-.4.63-.94.63-1.51,0-.57-.22-1.11-.63-1.51-.4-.4-.94-.63-1.51-.63Z"
  }))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://x.com/vaibhavwtf"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(196.16 828.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/ vaibhavwtf")), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M187.68,820.4s-.06.02-.09.04c-.76.24-1.37.74-1.74,1.38-.58,1.03-1.19,2.29-2.19,2.57-.76.21-1.51.43-2.27.64-.13.04-.21.18-.17.31.79,2.8,3.7,4.43,6.5,3.65,2.69-.75,4.31-3.51,3.74-6.18-.02-.09-.05-.21-.07-.31,0,0,0,0,0-.01-.32-.98-.93-1.6-1.62-1.91-.67-.3-1.39-.32-2.01-.18-.01,0-.03,0-.04,0,0,0-.01,0-.02,0,0,0,0,0,0,0h0s0,0,0,0ZM187.81,820.89c.53-.13,1.18-.11,1.75.15.57.26,1.07.75,1.35,1.61h0c.02.08.05.18.06.27.52,2.42-.95,4.91-3.38,5.6-2.45.68-5.02-.69-5.8-3.07.66-.18,1.36-.38,2.02-.57,1.3-.37,1.93-1.8,2.49-2.8.32-.56.85-1,1.52-1.19h0ZM188.75,824.32c-.13.04-.21.18-.17.31.21.78-.01,1.6-.58,2.17s-1.39.8-2.17.6c-.07-.02-.14-.01-.2.02-.06.03-.1.09-.12.16-.02.07,0,.14.03.19.04.06.09.1.16.11.95.24,1.96-.03,2.65-.73.69-.7.96-1.71.71-2.66-.02-.07-.06-.12-.12-.16-.06-.03-.13-.04-.19-.02h0ZM190.41,821.08l-.05.5,1.27.13-.7.73.36.35,1.05-1.1h0c.07-.07.09-.17.05-.26-.03-.09-.11-.15-.21-.16l-1.78-.18ZM188.69,821.69c-.33.09-.53.44-.44.77s.44.53.77.44.53-.44.44-.77-.44-.53-.77-.44ZM188.83,822.17c.07-.02.14.02.15.09s-.02.14-.09.15-.14-.02-.15-.09.02-.14.09-.15ZM186.81,819.6c-.07.02-.12.06-.15.12-.03.06-.04.13-.02.19s.06.12.12.15.13.04.19.02c.27-.07.54.08.61.35h0c.02.06.06.12.12.15.06.03.13.04.19.02s.12-.06.15-.12c.03-.06.04-.13.02-.19-.15-.53-.7-.85-1.23-.7h0ZM188.26,819.2c-.53.15-.84.7-.7,1.23.02.07.06.12.12.15.06.03.13.04.19.02s.12-.06.15-.12c.03-.06.04-.13.02-.19-.07-.27.08-.54.35-.61h0c.07-.02.12-.06.15-.12.03-.06.04-.13.02-.19s-.06-.12-.12-.15c-.06-.03-.13-.04-.19-.02h0Z"
  }))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://in.linkedin.com/in/vaibhavkothi"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(331.45 828.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/ vaibhavkothi")), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M316.37,821.21h0c.39,0,.7.32.7.7v5.63c0,.39-.32.7-.7.7h0c-.39,0-.7-.32-.7-.7v-5.63c0-.39.32-.7.7-.7ZM316.37,819.29h0c.39,0,.7.32.7.7h0c0,.39-.32.7-.7.7h0c-.39,0-.7-.32-.7-.7h0c0-.39.32-.7.7-.7ZM320.59,825.61v-.85c0-1.07.85-1.95,1.91-1.97s1.96.85,1.96,1.94v2.82c0,.39.32.7.7.7h0c.39,0,.7-.32.7-.7v-2.77c0-1.86-1.53-3.41-3.39-3.39-.7,0-1.36.24-1.89.62v-.09c0-.39-.32-.7-.7-.7h0c-.39,0-.7.32-.7.7v5.63c0,.39.32.7.7.7h0c.39,0,.7-.32.7-.7v-1.94Z"
  }))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://www.behance.net/vaibhav_kothi"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(469.17 828.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/ vaibhav_kothi")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M451.01,820.05c.6,0,1.18-.01,1.77,0,.96.02,1.93,0,2.88.11.91.11,1.35.6,1.5,1.39.16.89-.11,1.5-.89,2-.02.01-.04.03-.08.06.05.03.09.07.13.09.78.31,1.16.92,1.22,1.73.06.88-.23,1.62-1.04,2.03-.43.22-.93.38-1.4.4-1.36.05-2.72.02-4.1.02v-7.83ZM452.73,824.41v2.12c.75,0,1.48.05,2.2-.01.66-.06.93-.44.91-1.07-.02-.6-.37-1-.99-1.03-.7-.04-1.4,0-2.12,0ZM452.72,823.2c.68,0,1.34.02,1.99,0,.47-.02.76-.33.8-.78.04-.56-.15-.9-.68-.96-.69-.08-1.39-.08-2.11-.11v1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M463.78,825.42h-4.07c-.1.56.15,1.09.61,1.31.6.29,1.4.18,1.77-.31.18-.23.35-.29.62-.28.29.02.58,0,.92,0-.16.53-.41.95-.79,1.3-.95.85-3.48.95-4.38-.8-.81-1.57-.36-4.07,1.94-4.54,1.62-.33,3.01.64,3.29,2.28.05.32.06.65.1,1.02ZM459.67,824.43h2.49c-.1-.83-.54-1.24-1.29-1.21-.71.03-1.2.52-1.2,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M459.34,821.31v-.7h3.14v.7h-3.14Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/Resume.b2777cbedabd9a30f7a64cb96e42981d.svg";
export { ForwardRef as ReactComponent };